import React from "react";
import { Box, Grid, Typography, IconButton, Skeleton, useMediaQuery } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import KeyboardArrowUp from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import Star from "@mui/icons-material/Star";
import { useProductsOffers } from "../../../../../../../../context/OrderCreator/ProductContext";

const ProductFavoritesList = ({ onSelectProduct, imageBaseUrl, placeholderImage }) => {
  const { favorites = [], favoritesLoading, removeFromFavorites } = useProductsOffers();
  const scrollRef = React.useRef();

  // ✅ كشف دقيق لجميع مقاسات التابلت
  const isXSmallTablet = useMediaQuery("(min-width: 600px) and (max-width: 767px)");
  const isSmallTablet = useMediaQuery("(min-width: 768px) and (max-width: 834px)");
  const isMediumTablet = useMediaQuery("(min-width: 835px) and (max-width: 1024px)");
  const isLargeTablet = useMediaQuery("(min-width: 1025px) and (max-width: 1366px)");
  const isPortrait = useMediaQuery("(orientation: portrait)");

  const getScrollAmount = () => {
    if (isXSmallTablet) return 150;
    if (isSmallTablet) return 180;
    if (isMediumTablet) return 200;
    return 200;
  };

  const scrollUp = () => {
    scrollRef.current.scrollBy({ top: -getScrollAmount(), behavior: "smooth" });
  };

  const scrollDown = () => {
    scrollRef.current.scrollBy({ top: getScrollAmount(), behavior: "smooth" });
  };

  const getBranchId = () =>
    localStorage.getItem("branch_id") ||
    localStorage.getItem("branch id") ||
    localStorage.getItem("branchId") ||
    1;

  const getContainerHeight = () => {
    if (isXSmallTablet) return isPortrait ? 420 : 380;
    if (isSmallTablet) return isPortrait ? 450 : 400;
    if (isMediumTablet) return isPortrait ? 480 : 440;
    if (isLargeTablet) return 500;
    return 500;
  };

  const getButtonSize = () => {
    if (isXSmallTablet) return { width: 32, height: 32, fontSize: 18 };
    if (isSmallTablet) return { width: 34, height: 34, fontSize: 20 };
    if (isMediumTablet) return { width: 36, height: 36, fontSize: 22 };
    return { width: 36, height: 36, fontSize: 22 };
  };

  const getGridColumns = () => {
    if (isXSmallTablet) return isPortrait ? 3 : 4;
    if (isSmallTablet) return isPortrait ? 4 : 5;
    if (isMediumTablet) return isPortrait ? 4 : 6;
    if (isLargeTablet) return isPortrait ? 5 : 7;
    return 6;
  };

  const buttonSize = getButtonSize();
  const columns = getGridColumns();
  const columnWidth = `${100 / columns}%`;

  if (favoritesLoading) {
    return (
      <Box sx={{ width: "100%", p: 2 }}>
        <Skeleton variant="rectangular" height={400} />
      </Box>
    );
  }

  const items = Array.isArray(favorites)
    ? favorites.map((f) => (f && f.product ? f.product : f))
    : [];

  if (!items || items.length === 0) {
    return (
      <Box sx={{ p: 4, textAlign: "center" }}>
        <Typography sx={{ color: "rgba(255,255,255,0.7)", fontSize: 16 }}>
          لا توجد منتجات في المفضلة
        </Typography>
      </Box>
    );
  }

  return (
    <Box position="relative">
      <IconButton
        onClick={scrollUp}
        sx={{
          position: "absolute",
          top: { xs: 6, sm: 8, md: 10 },
          right: { xs: 6, sm: 8, md: 10 },
          zIndex: 40,
          width: buttonSize.width,
          height: buttonSize.height,
          minWidth: buttonSize.width,
          minHeight: buttonSize.height,
          background: "linear-gradient(135deg, #fbc2eb 0%, #ff9a9e 100%)",
          color: "#232334",
          boxShadow: "0 4px 12px rgba(251, 194, 235, 0.4)",
          transition: "all 0.3s ease",
          touchAction: "manipulation",
          WebkitTapHighlightColor: "transparent",
          "&:hover": {
            background: "linear-gradient(135deg, #ff9a9e 0%, #fbc2eb 100%)",
            transform: "scale(1.1)",
            boxShadow: "0 6px 20px rgba(251, 194, 235, 0.6)",
          },
          "&:active": {
            transform: "scale(0.95)",
          },
        }}
      >
        <KeyboardArrowUp sx={{ fontSize: buttonSize.fontSize }} />
      </IconButton>
      <IconButton
        onClick={scrollDown}
        sx={{
          position: "absolute",
          bottom: { xs: 6, sm: 8, md: 10 },
          right: { xs: 6, sm: 8, md: 10 },
          zIndex: 40,
          width: buttonSize.width,
          height: buttonSize.height,
          minWidth: buttonSize.width,
          minHeight: buttonSize.height,
          background: "linear-gradient(135deg, #fbc2eb 0%, #ff9a9e 100%)",
          color: "#232334",
          boxShadow: "0 4px 12px rgba(251, 194, 235, 0.4)",
          transition: "all 0.3s ease",
          touchAction: "manipulation",
          WebkitTapHighlightColor: "transparent",
          "&:hover": {
            background: "linear-gradient(135deg, #ff9a9e 0%, #fbc2eb 100%)",
            transform: "scale(1.1)",
            boxShadow: "0 6px 20px rgba(251, 194, 235, 0.6)",
          },
          "&:active": {
            transform: "scale(0.95)",
          },
        }}
      >
        <KeyboardArrowDown sx={{ fontSize: buttonSize.fontSize }} />
      </IconButton>

      <Box
        ref={scrollRef}
        sx={{
          height: getContainerHeight(),
          overflowY: "auto",
          overflowX: "hidden",
          pr: { xs: 0.5, sm: 0.75, md: 1 },
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
          WebkitOverflowScrolling: "touch",
          scrollBehavior: "smooth",
        }}
      >
        <Grid container spacing={{ xs: 1, sm: 1.5, md: 2 }}>
          {items.map((prod) => (
            <Grid
              item
              key={prod?.id || prod?.product_id || Math.random()}
              sx={{
                flexBasis: columnWidth,
                maxWidth: columnWidth,
                width: "100%",
              }}
            >
              <Box
                className="product-hover-card"
                sx={{
                  position: "relative",
                  borderRadius: { xs: 3, sm: 3.5, md: 4 },
                  overflow: "hidden",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                  bgcolor: "#1a1a2e",
                  border: "1px solid rgba(255,255,255,0.05)",
                  minHeight: { xs: 140, sm: 150, md: 160 },
                  cursor: "pointer",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  touchAction: "manipulation",
                  WebkitTapHighlightColor: "transparent",
                  "&:hover": {
                    boxShadow: "0 12px 40px rgba(251, 194, 235, 0.25)",
                    transform: "translateY(-8px) scale(1.02)",
                    border: "1px solid rgba(251, 194, 235, 0.3)",
                  },
                  "&:active": {
                    transform: "scale(0.98)",
                  },
                }}
                onClick={() => onSelectProduct && onSelectProduct(prod)}
                title={prod?.description || ""}
              >
                {/* زر النجمة لإزالة من المفضلة */}
                <IconButton
                  onClick={async (e) => {
                    e.stopPropagation();
                    const branchId = Number(getBranchId()) || 1;
                    try {
                      await removeFromFavorites([{ product_id: prod.id, root_id: branchId }]);
                    } catch (err) {
                      console.error("Remove favorite error:", err);
                    }
                  }}
                  sx={{
                    position: "absolute",
                    top: { xs: 8, sm: 10 },
                    left: { xs: 8, sm: 10 },
                    zIndex: 40,
                    width: { xs: 32, sm: 34, md: 36 },
                    height: { xs: 32, sm: 34, md: 36 },
                    bgcolor: "rgba(255, 213, 79, 0.95)",
                    backdropFilter: "blur(8px)",
                    color: "#000",
                    boxShadow: "0 4px 12px rgba(255, 193, 7, 0.4)",
                    transition: "all 0.3s ease",
                    touchAction: "manipulation",
                    "&:hover": {
                      bgcolor: "#ffc107",
                      transform: "scale(1.15) rotate(10deg)",
                      boxShadow: "0 6px 20px rgba(251, 194, 235, 0.5)",
                    },
                    "&:active": {
                      transform: "scale(0.95)",
                    },
                  }}
                >
                  <Star fontSize="small" />
                </IconButton>

                <Box
                  component="img"
                  src={prod?.image ? `${imageBaseUrl}${prod.image}` : placeholderImage}
                  alt={prod?.name}
                  sx={{
                    width: "100%",
                    height: { xs: 100, sm: 110, md: 120 },
                    objectFit: "cover",
                    display: "block",
                    filter: "brightness(0.75) contrast(1.1)",
                    transition: "all 0.3s ease",
                    pointerEvents: "none",
                    ".product-hover-card:hover &": {
                      filter: "brightness(0.85) contrast(1.15)",
                      transform: "scale(1.05)",
                    },
                  }}
                />

                <Box
                  sx={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    bottom: 0,
                    p: 0,
                    color: "#fff",
                    background: "linear-gradient(0deg, rgba(26,26,46,0.95) 70%, rgba(26,26,46,0.7) 85%, rgba(26,26,46,0) 100%)",
                    backdropFilter: "blur(4px)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "flex-end",
                    minHeight: { xs: 55, sm: 58, md: 60 },
                    height: { xs: "52px", sm: "55px", md: "58px" },
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: { xs: "0.9rem", sm: "0.95rem", md: "1rem" },
                      mb: 0,
                      px: { xs: 1.25, sm: 1.5, md: 1.75 },
                      pt: { xs: 0.9, sm: 1, md: 1.1 },
                      color: "#fff",
                      textShadow: "0 2px 8px rgba(0,0,0,0.6)",
                      letterSpacing: "0.3px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      width: "100%",
                    }}
                  >
                    {prod?.name || "بدون اسم"}
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      width: "100%",
                      alignItems: "center",
                      px: { xs: 1.25, sm: 1.5, md: 1.75 },
                      pb: { xs: 0.7, sm: 0.75, md: 0.85 },
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#fbc2eb",
                        fontSize: { xs: "0.9rem", sm: "0.95rem", md: "1rem" },
                        fontWeight: 700,
                        flex: 1,
                        textShadow: "0 1px 4px rgba(0,0,0,0.4)",
                      }}
                    >
                      {prod?.price}
                    </Typography>
                    <IconButton
                      sx={{
                        background: "linear-gradient(135deg, #fbc2eb 0%, #ff9a9e 100%)",
                        color: "#232334",
                        width: { xs: 28, sm: 30, md: 32 },
                        height: { xs: 28, sm: 30, md: 32 },
                        boxShadow: "0 4px 12px rgba(251, 194, 235, 0.4)",
                        transition: "all 0.3s ease",
                        touchAction: "manipulation",
                        "&:hover": {
                          background: "linear-gradient(135deg, #ff9a9e 0%, #fbc2eb 100%)",
                          transform: "scale(1.1) rotate(5deg)",
                          boxShadow: "0 6px 20px rgba(251, 194, 235, 0.6)",
                        },
                        "&:active": {
                          transform: "scale(0.95)",
                        },
                        ml: { xs: 0.75, sm: 1 },
                        p: 0,
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        onSelectProduct && onSelectProduct(prod);
                      }}
                    >
                      <AddIcon sx={{ fontSize: { xs: 16, sm: 18, md: 20 } }} />
                    </IconButton>
                  </Box>
                </Box>

                {/* وصف الصنف يظهر عند الوقوف عليه */}
                {prod?.description && (
                  <Box
                    className="product-description-hover"
                    sx={{
                      display: "block",
                      position: "absolute",
                      left: 0,
                      right: 0,
                      bottom: { xs: 52, sm: 55, md: 58 },
                      background: "linear-gradient(135deg, rgba(26,26,46,0.98) 0%, rgba(35,35,52,0.98) 100%)",
                      backdropFilter: "blur(10px)",
                      border: "1px solid rgba(251, 194, 235, 0.3)",
                      color: "#fff",
                      px: { xs: 1.5, sm: 1.75, md: 2 },
                      py: { xs: 1, sm: 1.25, md: 1.5 },
                      borderRadius: { xs: 2, sm: 2.5, md: 3 },
                      fontSize: { xs: 12, sm: 13, md: 13.5 },
                      fontWeight: 500,
                      lineHeight: 1.5,
                      zIndex: 50,
                      boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
                      opacity: 0,
                      pointerEvents: "none",
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      textAlign: "center",
                      maxWidth: "95%",
                      mx: "auto",
                      whiteSpace: "pre-line",
                    }}
                  >
                    {prod.description}
                  </Box>
                )}
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* CSS احترافي للهوفر */}
      <style>
        {`
          .product-hover-card {
            position: relative;
          }
          @media (hover: hover) and (pointer: fine) {
            .product-hover-card:hover .product-description-hover {
              opacity: 1 !important;
              pointer-events: auto !important;
              transform: translateY(-12px) scale(1.02);
              background: linear-gradient(135deg, rgba(26,26,46,0.98) 0%, rgba(251, 194, 235, 0.15) 100%);
              backdrop-filter: blur(12px);
              color: #fff;
              box-shadow: 0 12px 48px rgba(251, 194, 235, 0.3);
              border-color: rgba(251, 194, 235, 0.5);
            }
          }
        `}
      </style>
    </Box>
  );
};

export default ProductFavoritesList;
